import { jsx } from "react/jsx-runtime";
import { EditorTableRowElement } from "@contember/ui";
import { memo } from "react";
const TableRowElementRenderer = memo(function TableRowElementRenderer2(props) {
  return /* @__PURE__ */ jsx(EditorTableRowElement, { attributes: props.attributes, headerScope: props.element.headerScope, children: props.children });
});
export {
  TableRowElementRenderer
};
//# sourceMappingURL=TableRowElementRenderer.js.map
